import { getCompMeta } from '../index';
import { get, cloneDeep } from "lodash-es";
// 这里情况比较多 先处理children的转换 后续复杂的弹出ui来用户拖拽
// 容器替换用手动很难cover 通用的容器到容器用装入拆除实现
// 如果用户有特殊需求自定义了containerReplace才用这里
export const replace = ({
  ctx,
  sourceLayout,
  targetCompId,
  targetLayout
}) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const sourceMeta = getCompMeta(ctx, sourceLayout.type);
  const targetMeta = getCompMeta(ctx, targetCompId);
  const newLayout = targetLayout || cloneDeep(sourceLayout);
  if (!targetMeta.slots) return {
    layout: newLayout
  };
  const slots = Array.isArray(targetMeta.slots) ? targetMeta.slots : targetMeta === null || targetMeta === void 0 ? void 0 : targetMeta.slots(sourceLayout);
  if (sourceLayout.children) {
    // 考虑装到target中 提取动态插槽
    if (Array.isArray(slots) && slots.length > 0) {
      const hasDefaultSlot = slots.some(slot => slot.id === 'default');
      if (hasDefaultSlot) {
        newLayout.children = sourceLayout.children;
      } else {
        delete newLayout.children;
        // 找一个合适的插槽放进去
        const slotId = get(slots, [0, 'id']);
        newLayout.slots = {
          ...newLayout.slots,
          [slotId]: sourceLayout.children
        };
      }
    }
  } else {
    if (Array.isArray(slots) && slots.length > 0) {
      // 源组件有插槽
      const slotId = Object.keys(sourceLayout.slots || {})[0];
      if (slotId) {
        // 插槽放进去
        const slotContext = sourceLayout.slots[slotId];
        const hasDefaultSlot = slots.some(slot => slot.id === 'default');
        if (hasDefaultSlot) {
          newLayout.children = slotContext;
        } else {
          const slotId = get(slots, [0, 'id']);
          newLayout.slots = {
            ...newLayout.slots,
            [slotId]: slotContext
          };
        }
      }
    }
  }
  return {
    layout: newLayout
  };
};
//# sourceMappingURL=containerReplace.js.map
